module.exports = {
  title: '展示页管理',
  route: {
    path: '/content-manage',
    children: {
      path: 'config-page-form',
    },
  },
};
